import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ['playIcon', 'video', 'videoImage']

  connect() {
  }

  play(event) {
    this.videoImageTarget.classList.add('hide')
    this.playIconTarget.classList.add('hide')
    this.videoTarget.classList.add('show')
    this.videoTarget.play()
  }

}
